<!-- src/components/shared/UserAvatar.vue -->
<!--
  Единый аватар пользователя: реальное фото (avatar_url) → чистый инициал имени.
  Gravatar намеренно НЕ используем — его дефолтный identicon («монстр») уродлив и
  даёт «везде разное». Фото есть только у того, у кого оно реально загружено
  (сейчас — currentUser через /me); у остальных — аккуратная буква.
  На нативе (Capacitor) внешние картинки пропускаем. Размер/цвет/loading — пропсами.
  Пример: <UserAvatar :size="20" :name="u.name" color="grey lighten-1" />
-->
<template>
  <v-avatar :size="size" :color="color">
    <v-progress-circular v-if="loading" indeterminate :size="spinnerSize" width="2" color="white" />
    <template v-else>
      <v-img v-if="showPhoto" :src="avatarUrl" :alt="name || ''" class="grey lighten-2" @error="photoFailed = true">
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate :size="spinnerSize" width="2" color="grey lighten-5" />
          </v-row>
        </template>
      </v-img>
      <span v-else class="white--text" :style="{ fontSize: initialSize }">{{ initial }}</span>
    </template>
  </v-avatar>
</template>

<script>
import { Capacitor } from "@capacitor/core";

export default {
  name: "UserAvatar",
  props: {
    name: { type: String, default: "" },
    avatarUrl: { type: String, default: "" },
    size: { type: [Number, String], default: 36 },
    color: { type: String, default: "primary" },
    loading: { type: Boolean, default: false },
  },
  // Фото, которое браузер не декодирует (HEIC/TIFF в Chrome), — инициал вместо вечного спиннера.
  data() {
    return { photoFailed: false };
  },
  watch: {
    avatarUrl() {
      this.photoFailed = false;
    },
  },
  computed: {
    isNative() {
      return Capacitor.isNativePlatform();
    },
    showPhoto() {
      return !this.isNative && !!this.avatarUrl && !this.photoFailed;
    },
    initial() {
      const src = (this.name || "").trim();
      return src ? src.charAt(0).toUpperCase() : "?";
    },
    sizePx() {
      return parseInt(this.size, 10) || 36;
    },
    initialSize() {
      return Math.max(10, Math.round(this.sizePx * 0.42)) + "px";
    },
    spinnerSize() {
      return Math.max(12, Math.round(this.sizePx * 0.7));
    },
  },
};
</script>
